  <template>
  <div>
   <b-modal style="padding:15px" size="lg" id="AddWheatReceivedModal" ref="modal" title="Add Wheat Received" ok-title="Submit" cancel-title="Close" 
      @hidden= "resetModal()" @ok= "handleOk" :ok-disabled = "this.$refs.AddWheatReceiveForm != undefined ? !this.$refs.AddWheatReceiveForm.checkValidity() : true">
        <form ref="AddWheatReceiveForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
            <div class = "col-md-12">
              <b-form-group  label="" label-for="checkbox" autocomplete="off">
               <b-form-checkbox
                id="checkbox"
                v-model="IsNonInventory"
                name="checkbox-1"
                value: = true
                unchecked-value: = false
              >
               Non Inventory Transaction
              </b-form-checkbox>
              </b-form-group>
            </div>
            <div class="col-md-6">
               <b-form-group  label="Date Received" label-for="datepicker-2" autocomplete="off">
                  <b-form-datepicker id="datepicker-1" v-model= "DateReceived" placeholder="Choose a date" local="en"></b-form-datepicker>
               </b-form-group>
            </div>  
            <div class="col-md-6">
               <b-form-group  label="Vendor Issued Date" label-for="datepicker-2" autocomplete="off">
                  <b-form-datepicker id="datepicker-2" v-model= "DateIssued" placeholder="Choose a date" local="en"></b-form-datepicker>
               </b-form-group>
            </div>  
            <div class = "col-md-6">
              <b-form-group  label="Truck No" label-for="truckno" autocomplete="off">
                <b-form-input id="truckno" v-model= "TruckNo"  required></b-form-input>
              </b-form-group>
            </div>
            <div class = "col-md-6">
              <b-form-group  label="Voucher No" label-for="voucherno" autocomplete="off">
                <b-form-input id="voucherno" v-model= "VoucherNo"  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="Type" label-for="Type" autocomplete="off">
                <b-form-select v-model= "SelectedTypeId" :options="wheatTypes" value-field="id" text-field="name">
                  <b-form-select-option :value = null disabled hidden>Select Type</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="Wheat Received From">
                <b-form-radio-group
                  v-model="IsGovt"
                  :options="flourOptions"
                  name="radio-inline"
                ></b-form-radio-group>
              </b-form-group>
            </div>
             <div class = "col-md-6">
              <b-form-group  label="No Of Sacks" label-for="sacks" autocomplete="off">
                <b-form-input id="sacks" v-model= "NoOfSacks" type = "number"  required></b-form-input>
              </b-form-group>
            </div>
             <div class = "col-md-6">
              <b-form-group  label="Total Weight" label-for="totalweight" autocomplete="off">
                <b-form-input id="totalweight" v-model= "TotalWeight" type = "number"  required></b-form-input>
              </b-form-group>
            </div>
          </div>
          
        </form>
      </b-modal>
      <Toaster ref ="toaster"/>
      </div>
      </template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Toaster from '../../toaster'
export default {
    name: 'AddWheatReceive',
    mounted()
    {
      // console.log(this.$auth.user())
      let model = {
        companyId:this.$auth.user().companyId
      }
       axios.post('/wheattype/getall', model)
      .then(res=>{
        // console.log(res)
        this.wheatTypes = res.data.data
      });
    },
    components:{
      Toaster
    },
    data(){
        return{
          moduleName:'Edit Wheat Type',   
          TotalWeight:null,
          NoOfSacks: 1,
          IsGovt:true,
          flourOptions: [
          { text: 'Govt', value: true },
          { text: 'Private', value: false },
          ],
          VoucherNo: null,
          TruckNo : null,
          DateIssued:null,
          DateReceived:null,
          IsNonInventory:false,
          wheatTypes:[],
          SelectedTypeId:null
          
		}
  },

 props:
 {
   role:{
     type:Object,
     default:null
   }
 },


methods:{
  
   addWheatReceive(){ 
      let model = {"TotalWeight":parseFloat(this.TotalWeight),"NoOfSacks":parseInt(this.NoOfSacks),"IsGovt":this.IsGovt,"VoucherNo":this.VoucherNo,
       "TruckNo":this.TruckNo,"DateIssued":this.DateIssued,"DateReceived":this.DateReceived,
       "IsNonInventory":this.IsNonInventory,"WheatTypeId":this.SelectedTypeId,
       "CompanyId":this.$auth.user().companyId,"UserId":this.$auth.user().id
      }
      console.log(model)
     axios.post('/wheatreceives/Add', model
      )
      .then(res=>{
        // console.log(res)
            if(res.data.status == 1)
            {
                 this.$refs.toaster.showToast('Sucess','success','Wheat has been added successfully')
                this.$bvModal.hide('AddWheatReceivedModal')
                 this.$parent.getWheatReceives();      
     
            }
            else
            {
               this.$refs.toaster.showToast('Error','danger',res.data.msg)      
            }
           
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.AddWheatReceiveForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
     
      resetModal() {
     
      this.TotalWeight = null;
      this.NoOfSacks = 1;
      this.IsGovt = true;
      this.VoucherNo=null;
      this.TruckNo = null;
      this.DateIssued = null;
      this.DateReceived = null;
      this.IsNonInventory = false;
      this.SelectedTypeId = null;
      
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.addWheatReceive()
       
        // this.$nextTick(() => {
        //   //this.$router.go('/phones')
        //   this.$bvModal.hide('AddWheatReceivedModal')
        
        // })
      },

 

  }
	

}
</script>
